const BLUE_KOREM = "rgb(0, 110, 213)";
const YELLOW_KOREM = "rgb(255, 221, 0)";
const WHITE_KOREM = "rgb(255,255,255)";
export const GREY_KOREM = "rgb(189,187,187)";
export const DEFAULT_BORDER = 1;

export const DEFAULT_COLOR = [
    BLUE_KOREM,
    YELLOW_KOREM,
    WHITE_KOREM,
    GREY_KOREM
];

export default class PieAssembler {
    toChartJs(dataJson) {
        let labels = [];
        let data = [];
        dataJson.forEach(dat => {
            labels = [...labels, ...Object.keys(dat)];
            data = [...data, ...Object.values(dat)];
        });
        return {
            labels,
            datasets: [{
                data,
                borderColor: GREY_KOREM,
                border: DEFAULT_BORDER,
                backgroundColor: DEFAULT_COLOR,
                hoverBackgroundColor: DEFAULT_COLOR
            }]
        }
    }
}